/**
 * Format a utterance timestamp into HH:MM:SS.s with the ability to show or hide hours.
 *
 * @example
 * "00:33:45.2"
 */
export const getReadableTime = (time: number, showHours?: boolean): string => {
  return new Date(time * 1000).toISOString().slice(showHours ? 11 : 14, 22);
};
